const DAY_IN_MS = 86400000;

export function isAfter24Hours(date: string) {
  const createdAtDate = new Date(date).getTime();
  const currentDate = new Date(new Date().toUTCString()).getTime();

  return currentDate - createdAtDate >= DAY_IN_MS;
}
